// Types
import type { TRadioControl } from '~/misc/v-radio-control/types';
import { ESaleType } from '~/misc/listings/types';

const SALE_TYPE_OPTIONS: TRadioControl[] = [
  { label: 'Sales', value: ESaleType.SALES },
  { label: 'Lettings', value: ESaleType.LETTINGS },
];

export { SALE_TYPE_OPTIONS };
